export const CLOSE_ACTION_KEY_STORAGE = 'ligo-bots-webchat-close-action';
